import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownToggle, Form } from "reactstrap";

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";
import logoLarge from "../assets/images/K2Charge.png";
import logoSmall from "../assets/images/logo-small.png";
import LightDark from "../Components/Common/LightDark";

//import Components
import FullScreenDropdown from "../Components/Common/FullScreenDropdown";
import ProfileDropdown from "../Components/Common/ProfileDropdown";

import { changeSidebarVisibility } from "../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { viewDoc } from "../slices/customer/documentview/thunk";
import { fetchDocumentsForCustomer } from "../slices/customer/documentlist/thunk";
import { Loader } from "../Components/Utils/Loader";
import { logoViewDoc } from "../slices/Logo/thunk";
import { fetchOperatorbyId } from "../slices/OperatorManagement/GetOperatorbyID/thunk";
import { logoHeaderViewDoc } from "../slices/Logo/HeaderLogo/thunk";
import { Images } from "../Components/Utils/ImagePath";
import { Logo } from "./Logo";
import { getNotification } from "../slices/Notification/GetNotification/thunk";
import { hasPermission } from "../Components/Utils/UtilityFunctions";

const HeaderComponent = ({
  onChangeLayoutMode,
  layoutModeType,
  headerClass,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sidebarVisibilitytype } = useSelector((state) => state.Layout);

  const [search, setSearch] = useState(false);
  const [profileData, setProfileData] = useState(false);
  const [loading, setLoading] = useState();
  const [editData, setEditData] = useState(null);
  const userId = localStorage.getItem("userId");
  const toogleSearch = () => {
    setSearch(!search);
  };
  const roleName = localStorage.getItem("roleName");
  const rawPermissions = useSelector(
      (state) => state.permissions.permissionsMap
    );
  
  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const notificationsPermission = hasPermission(permissionsMap, "monitoringandcontrol", "notifications");

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    dispatch(changeSidebarVisibility("show"));

    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //For collapse vertical and semibox menu
    if (
      sidebarVisibilitytype === "show" &&
      (document.documentElement.getAttribute("data-layout") === "vertical" ||
        document.documentElement.getAttribute("data-layout") === "semibox")
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };
  const operatorName = localStorage.getItem("operatorName") || "";
  const operatorId = localStorage.getItem("operatorId")?.split("/").pop() || "";
  const operatorLogoName = roleName === "systemUser" ? "logoSys" : "logo";
  const operatorNameFinal = operatorName === "undefined" ? "" : operatorName;
  let base64ImageData = [];

  if (roleName !== "Customer") {
    useEffect(() => {
      const partnerOrCustomer =
        roleName === "systemUser" ? "Business" : "Operator";
      const id = roleName === "systemUser" ? userId : operatorId;
      dispatch(
        logoHeaderViewDoc(
          setLoading,
          id,
          operatorLogoName,
          partnerOrCustomer,
          setProfileData
        )
      );
    }, [dispatch, roleName, operatorId, userId, operatorLogoName]);
  } else null;

  let profile = useSelector((state) => state.logoHeaderView.logoHeader);
  if (roleName !== "systemUser") {
    base64ImageData = profile?.filePath || [];
  } else if (roleName === "systemUser") {
    base64ImageData = profile?.filePath || [];
  } else {
    base64ImageData = [];
  }
  const initialValues = [];
  const operatorOptions = [];
  const OperatorStatusOptions = [];
  if (roleName !== "Customer" && roleName !== "EVPartnerAdmin" && roleName !== 'ISPPartnerAdmin' && roleName !== 'partnerAdmin') {
    useEffect(() => {
      dispatch(
        fetchOperatorbyId(
          setLoading,
          operatorId,
          initialValues,
          operatorOptions,
          OperatorStatusOptions,
          setEditData
        )
      );
    }, [dispatch]);
  } else null;

   useEffect(() => {
    if(notificationsPermission){
      dispatch(getNotification());
    }
    }, [dispatch]);

  const operatorData = useSelector(
    (state) => state?.GetOperator?.GetOperatorId ?? null
  );
  
useEffect(() => {
  if (operatorData?.tradingName) {
    localStorage.setItem(
      "tradingName",
      operatorData.tradingName.toLowerCase()
    );
  }
}, [operatorData]);
  const notificationData = useSelector(
    (state) => state?.GetNotification?.allNotifications ?? null
  );
  const handleNavigate = () => {
  const hasPendingStockInRequest =
    notificationData.pendingCount > 0 &&
    notificationData.notifications?.some(
      (item) =>
        item.type?.toLowerCase() === "stock in request" || item.type?.toLowerCase() === "stockinrequest"
    );

    navigate("/notifications", {
      state: {
        selectedTab: hasPendingStockInRequest
          ? "purchase order"
          : "sales order",
        expandMenu: "monitoringAndControl",
      },
    });
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        {loading && <Loader />}
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
              <div className="d-flex align-items-right">
                <Link className="logo logo-light">
                  <span className="logo-sm">
                    {/* <img src={profile?.filePath && roleName !== "systemUser" ? base64ImageData || Images.logoNewBlack :roleName === "systemUser" ? base64ImageData || Images.logoNewBlack : Images.logoNewBlack} alt="" className='logo-image-lg' height="30" /> */}
                    <Logo
                      src={
                        (profile?.filePath && roleName !== "systemUser") ||
                          roleName === "systemUser"
                          ? base64ImageData
                          : null
                      }
                      alt="logo"
                    />
                  </span>
                </Link>
              </div>
            </div>
            <div className="d-flex align-items-center ">
              {/* FullScreenDropdown */}
              <FullScreenDropdown />
              {notificationsPermission && (
                <div
                  className="notification-wrapper"
                  onClick={handleNavigate}
                >
                  <i className="ri-notification-2-line notification-icon text-muted"></i>

                  {notificationData?.pendingCount > 0 && (
                      <span className="notification-badge" style={{ right: notificationData?.pendingCount > 99 ? "-25px" : notificationData?.pendingCount > 9 ? "-15px" : "-10px" }}>
                      {notificationData?.pendingCount}
                      </span>
                  )}
              </div>
              )}
              {/* Dark and Bright theme mode */}
              {roleName === "Customer" ? (
                <LightDark
                  layoutMode={layoutModeType}
                  onChangeLayoutMode={onChangeLayoutMode}
                />
              ) : null}
              {/* ProfileDropdown */}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default HeaderComponent;
